import { createFileRoute } from '@tanstack/react-router';

import {
  auctionsReportQueryOptions,
  AuctionsReportPage,
  resolveRange,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/auctions')({
  staticData: { crumb: 'reports:tabs.auctions', tours: ['reports.auctions'] },
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .infiniteQuery({
        ...auctionsReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: AuctionsReportPage,
});
